import { useMap } from "react-leaflet";

export function GeomanLanguage() {
  const map = useMap();
  map.pm.setLang("nl");
  return null;
}
